let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aPZso")).then(() => parcelRequire('27Ap3'));